import { OneOfDeliveryVariant } from 'pages/CreateOrder/deliveryOptions'
import { CreateOrderBPostPointData, CreateOrderShippingAddress } from 'pages/CreateOrder/types'

export const getNestedName = (
  variant: OneOfDeliveryVariant,
  name: keyof (CreateOrderShippingAddress & CreateOrderBPostPointData)
) => `${variant}.${name}`
